<template>
  <v-btn icon :small="small" :color="color" :disabled="disabled" :aria-label="ariaLabel" v-on="$listeners">
    <v-icon :small="small" data-testid="icon">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'icon-button',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      required: true,
    },
    small: Boolean,
    disabled: Boolean,
    ariaLabel: {
      type: String,
      default: null,
    },
  },
};
</script>
